import {
  Button, IconChevron, IconFeatured, Modal,
  Toggle,
} from 'gatorcomponents';
import * as Styles from './CloudflareTopBanner.styles';
import React, { useState } from 'react';
import useLocale from '@/hooks/useLocale';
import { CloudflareLogo } from './media/CloudflareLogo';
import { MODAL_STEPS, STEPS_NAMES } from './CloudflareTopBanner.types;';
import { useHistory } from 'react-router';
import { cloudflareAnalytics } from '@/analytics/cloudflare';

const CloudflareTopBanner = () => {
  const [showExplanationModal, setShowExplanationModal] = useState(false);
  const { cloudflare: cloudflareLocale } = useLocale();
  const { topBanner: cloudflareTopBannerLocale } = cloudflareLocale;
  const [modalStep, setModalStep] = useState(MODAL_STEPS.KNOW);
  const history = useHistory();
  const { routes: routesLocale } = useLocale();

  const modalSteps = {
    [MODAL_STEPS.KNOW]: {
      title: cloudflareTopBannerLocale.modal.know.title,
      description: cloudflareTopBannerLocale.modal.know.description,
      icon: 'IconCdn',
      secondaryColor: 'pendingUltraLight',
      backgroundColor: 'pendingMedium',
      withToggle: false,
    },
    [MODAL_STEPS.SPEED]: {
      title: cloudflareTopBannerLocale.modal.speed.title,
      description: cloudflareTopBannerLocale.modal.speed.description,
      icon: 'IconSpeed',
      secondaryColor: 'attentionUltraLight',
      backgroundColor: 'attentionPure',
      withToggle: false,
    },
    [MODAL_STEPS.STABILITY]: {
      title: cloudflareTopBannerLocale.modal.stability.title,
      description: cloudflareTopBannerLocale.modal.stability.description,
      icon: 'IconLive',
      secondaryColor: 'attentionUltraLight',
      backgroundColor: 'primaryBlue',
      withToggle: false,
    },
    [MODAL_STEPS.SAFETY]: {
      title: cloudflareTopBannerLocale.modal.safety.title,
      description: cloudflareTopBannerLocale.modal.safety.description,
      icon: 'IconSecurityCheck',
      secondaryColor: 'activeUltraLight',
      backgroundColor: 'activeLight',
      withToggle: false,
    },
    [MODAL_STEPS.SETTUP]: {
      icon: 'IconSpeed',
      color: 'transparent',
      withToggle: true,
      backgroundColor: 'primaryUltralight',
      title: cloudflareTopBannerLocale.modal.settup.title,
      description: cloudflareTopBannerLocale.modal.settup.description,
      cta: cloudflareTopBannerLocale.modal.settup.cta,
    },
  };

  const handleDisplayModal = () => {
    cloudflareAnalytics.sitesBannerCta();
    setShowExplanationModal(true);
  };

  const handleRedirect = () => {
    cloudflareAnalytics.modalCta();
    history.push(`${routesLocale.products}${routesLocale.cloudflare}`);
  };

  const handleCloseModal = () => {
    cloudflareAnalytics.modalClose();
    setShowExplanationModal(false);
  };

  return (
    <>
      {showExplanationModal && (
        <Modal
          maxWidth={800}
          onClose={handleCloseModal}
          title={cloudflareTopBannerLocale.modal.title}
        >
          <Styles.ModalContent data-testid={`content-step-${STEPS_NAMES[modalStep]}`}>
            <Styles.IconWrapper transparent={!!modalSteps[modalStep].withToggle}>
              {modalSteps[modalStep].withToggle
                && <Toggle checked controlledByFather />
              }

              <IconFeatured
                icon={modalSteps[modalStep].icon}
                secondaryColor={modalSteps[modalStep].secondaryColor}
                backgroundColor={modalSteps[modalStep].backgroundColor}
                size="default"
              />
            </Styles.IconWrapper>

            <Styles.ModalTitle>
              {modalSteps[modalStep].title}
            </Styles.ModalTitle>

            <Styles.ModalDescription>
              {modalSteps[modalStep].description}
            </Styles.ModalDescription>

            {modalSteps[modalStep].cta && (
              <Styles.ButtonRow>
                <Button
                  label={modalSteps[modalStep].cta}
                  onClick={handleRedirect}
                  size="large"
                  width="fit-content"
                  testId="redirect-cta"
                />
              </Styles.ButtonRow>
            )}

            {modalStep !== MODAL_STEPS.KNOW && (
              <Styles.BackButton
                data-testid="back-cta"
                onClick={() => setModalStep(modalStep - 1)}
              >
                <IconChevron direction="left" color="primaryMedium" />
              </Styles.BackButton>
            )}

            {modalStep !== MODAL_STEPS.SETTUP && (
              <Styles.NextButton
                data-testid="next-cta"
                onClick={() => setModalStep(modalStep + 1)}
              >
                <IconChevron direction="right" color="primaryMedium" />
              </Styles.NextButton>
            )}
          </Styles.ModalContent>
        </Modal>
      )}

      <Styles.BannerWrapper>
        <Styles.BannerContainer>
          <CloudflareLogo />
          <Styles.Title>{cloudflareTopBannerLocale.title}</Styles.Title>
          <Styles.Description>{cloudflareTopBannerLocale.description}</Styles.Description>
          <Styles.ButtonWrapper>
            <Button
              testId="modalCta"
              variant="secondary"
              label={cloudflareTopBannerLocale.cta}
              onClick={handleDisplayModal}
            />
          </Styles.ButtonWrapper>
        </Styles.BannerContainer>

        <Styles.BottomImage />
      </Styles.BannerWrapper>
    </>
  );
};

export default CloudflareTopBanner;
